const RegulationCodes = Object.freeze({
  regulamin: 'web_regulation',
  politykaPrywatnosci: 'web_privacy_policy',
  politykaCookies: 'web_cookies_policy',
});

export default RegulationCodes;
